export interface LegendEntry {
  label: string;
  color: string;
  /** Shown after the label, e.g. the slice total in the donut legend. */
  value?: number;
}

const ChartLegend = ({ entries }: { entries: LegendEntry[] }) => (
  <div className="admin-report__legend">
    {entries.map(({ label, color, value }) => (
      <span key={label} className="admin-report__legend-item">
        <span
          className="admin-report__legend-swatch"
          style={{ backgroundColor: color }}
        />
        {label}
        {value !== undefined && (
          <span className="admin-report__legend-value">
            {value.toLocaleString("en-US")}
          </span>
        )}
      </span>
    ))}
  </div>
);

export default ChartLegend;
